import React from "react";

import { formatDateTime } from "../../../shared/dateTimeUtils";
import * as _ from "lodash";

export default function ECGTile({ model, key, title }) {
  return (
    <React.Fragment>
      <div className="title">
        {title}
        <div className="count">{model.count}</div>
      </div>
      <div className="tile-content ecgs" ref={key}>
        {_.get(model.testlist, "length") ? (
          model.testlist.map((ecg, i) => (
            <div className="ecg" key={i}>
              <div className="diagnosis">{ecg.diagnosis}</div>
              <div className="date">{formatDateTime(ecg.date, "-")}</div>
            </div>
          ))
        ) : model.count ? (
          <div className="number">{model.count}</div>
        ) : (
          <div className="no-results">No ECGs</div>
        )}
      </div>
    </React.Fragment>
  );
}
